export default __webpack_public_path__ + "static/media/kryptosc_500.c4eb4cea.png";